import React from 'react';
import {Link, useLocation} from 'react-router-dom';
import {motion} from 'framer-motion';
import {useAuth} from '../contexts/AuthContext';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiLogOut, FiSettings, FiHome, FiBarChart3} = FiIcons;

export default function Header() {
  const {user, logout} = useAuth();
  const location = useLocation();
  
  // Navigation nur für Admins und Basis für alle
  const navigation = [
    {name: 'Dashboard', href: '/', icon: FiHome}
  ];
  
  // Admin-Link nur für Admin-Benutzer
  if (user?.role === 'admin') {
    navigation.push({name: 'Administration', href: '/admin', icon: FiSettings});
  }

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center space-x-8">
            <Link to="/" className="flex items-center space-x-3">
              <div className="bg-gradient-to-r from-[#9b061b] to-[#1e314b] w-10 h-10 rounded-lg flex items-center justify-center">
                <SafeIcon icon={FiBarChart3} className="text-white text-xl" />
              </div>
              <div>
                <h1 className="text-xl font-bold text-[#1e314b]">CBUY.EXPERT</h1>
                <p className="text-xs text-gray-500">Energievertrieb</p>
              </div>
            </Link>
            <nav className="hidden md:flex space-x-6">
              {navigation.map((item) => {
                const isActive = location.pathname === item.href;
                return (
                  <Link 
                    key={item.name} 
                    to={item.href} 
                    className={`flex items-center space-x-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                      isActive ? 'bg-[#9b061b] text-white' : 'text-gray-600 hover:text-[#9b061b] hover:bg-gray-50'
                    }`}
                  >
                    <SafeIcon icon={item.icon} className="text-lg" />
                    <span>{item.name}</span>
                  </Link>
                );
              })}
            </nav>
          </div>
          <div className="flex items-center space-x-4">
            <div className="text-right">
              <p className="text-sm font-medium text-gray-900">{user?.name}</p>
              <p className="text-xs text-gray-500 capitalize">{user?.role}</p>
            </div>
            <motion.button 
              whileHover={{scale: 1.05}} 
              whileTap={{scale: 0.95}} 
              onClick={logout} 
              className="p-2 text-gray-400 hover:text-[#9b061b] hover:bg-gray-50 rounded-lg transition-colors" 
              title="Abmelden"
            >
              <SafeIcon icon={FiLogOut} className="text-xl" />
            </motion.button>
          </div>
        </div>
      </div>
    </header>
  );
}